module.exports = __webpack_public_path__ + "static/media/PricingWorkspaceStep2.df36d240.jpg";